// extracted by mini-css-extract-plugin
module.exports = {"container":"JlPqi","arrow":"_3V3v1"};